module.exports = __webpack_public_path__ + "static/media/img2.63718da2.png";